import { useContext } from 'react';

import { BonusProgramMetricAssignmentsContext } from 'contextProviders/SplashScreenProviders/ContentDependantProviders/BonusProgramMetricAssignmentsProvider';

export type { BonusProgramAssignments } from 'contextProviders/SplashScreenProviders/ContentDependantProviders/BonusProgramMetricAssignmentsProvider';

/**
 * Bonus program metric assignments, loaded once per account by
 * `BonusProgramMetricAssignmentsProvider`.
 */
const useBonusProgramMetricAssignments = () =>
  useContext(BonusProgramMetricAssignmentsContext);

export default useBonusProgramMetricAssignments;
